import { match } from 'ts-pattern'

import type { ExploreFeedType } from './explore-feed-type'

export const Type = {
  OneColumn: 'OneColumn::ExploreLayoutType',
  TwoColumns: 'TwoColumns::ExploreLayoutType',
  ThreeColumns: 'ThreeColumns::ExploreLayoutType',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Type = (typeof Type)[keyof typeof Type]

export const types = [Type.OneColumn, Type.TwoColumns, Type.ThreeColumns]

export enum Column {
  First = 0,
  Second = 1,
  Third = 2,
}

export type Columns = [ExploreFeedType, ExploreFeedType, ExploreFeedType]

export const changeColumnFeed = (
  columns: Columns,
  column: Column,
  feed: ExploreFeedType,
): Columns => {
  const current = columns[column]!
  if (current === feed) {
    return columns
  }
  const existing = columns.findIndex((c) => c === feed)
  if (existing === -1) {
    return columns.map((itFeed, itColumn) =>
      itColumn === column ? feed : itFeed,
    ) as Columns
  }
  const updated = [...columns]
  updated[existing] = current
  updated[column] = feed
  return updated as Columns
}

export const type = (columns: Array<ExploreFeedType>) => {
  match(columns.length)
    .with(1, () => Type.OneColumn)
    .with(2, () => Type.TwoColumns)
    .otherwise(() => Type.ThreeColumns)
}

export const columnsCount = (type: Type) => {
  return match(type)
    .with(Type.OneColumn, () => 1)
    .with(Type.TwoColumns, () => 2)
    .with(Type.ThreeColumns, () => 3)
    .exhaustive()
}
